// // import React, { useState } from 'react';
// // import { motion, AnimatePresence } from 'framer-motion';

// // const ImageViewer = ({ src, alt, onClick }) => {
// //   const [isHovered, setIsHovered] = useState(false);

// //   return (
// //     <div 
// //       className="relative rounded-lg overflow-hidden cursor-zoom-in"
// //       onMouseEnter={() => setIsHovered(true)}
// //       onMouseLeave={() => setIsHovered(false)}
// //       onClick={onClick}
// //     >
// //       <img
// //         src={src}
// //         alt={alt}
// //         className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
// //         onError={(e) => {
// //           e.target.src = '/images/placeholder.jpg';
// //           console.error(`Błąd ładowania obrazu: ${src}`);
// //         }}
// //       />
// //       {isHovered && (
// //         <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center">
// //           <span className="text-white font-bold text-lg bg-black bg-opacity-50 px-3 py-1 rounded-md">
// //             Powiększ
// //           </span>
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // const OfferCard = ({ image, title, shortDescription, fullDescription, reverse = false, galleryImages = [] }) => {
// //   const [showPopup, setShowPopup] = useState(false);
// //   const [showFullGallery, setShowFullGallery] = useState(false);
// //   const [currentImage, setCurrentImage] = useState(null);

// //   const popupVariants = {
// //     hidden: { 
// //       opacity: 0,
// //       scale: 0.8,
// //       transition: { duration: 0.2 }
// //     },
// //     visible: { 
// //       opacity: 1,
// //       scale: 1,
// //       transition: { 
// //         duration: 0.3,
// //         ease: "easeOut"
// //       }
// //     },
// //     exit: {
// //       opacity: 0,
// //       scale: 0.8,
// //       transition: { duration: 0.2 }
// //     }
// //   };

// //   const overlayVariants = {
// //     hidden: { opacity: 0 },
// //     visible: { opacity: 1 }
// //   };

// //   const openImage = (img) => {
// //     setCurrentImage(img);
// //   };

// //   const closeImage = () => {
// //     setCurrentImage(null);
// //   };

// //   return (
// //     <div className={`flex flex-col ${reverse ? 'md:flex-row-reverse' : 'md:flex-row'} gap-6 md:gap-8 lg:gap-12 rounded-lg shadow-lg overflow-hidden bg-white`}>
// //       {/* Sekcja zdjęcia */}
// //       <div className="md:w-1/2">
// //         <div className="aspect-w-16 aspect-h-9 md:aspect-w-4 md:aspect-h-3">
// //           <img
// //             src={image}
// //             alt={title}
// //             className="w-full h-full object-cover"
// //           />
// //         </div>
// //       </div>

// //       {/* Sekcja opisu */}
// //       <div className={`p-6 md:p-8 md:w-1/2 flex flex-col ${reverse ? 'md:text-right' : 'md:text-left'}`}>
// //         <h3 className="text-2xl md:text-3xl font-bold mb-4 text-gray-800">{title}</h3>
// //         <p className="text-gray-600 mb-6">{shortDescription}</p>
        
// //         <button 
// //           onClick={() => setShowPopup(true)}
// //           className="mt-2 bg-yellow-500 hover:bg-yellow-600 text-white py-2 px-6 rounded-md transition-colors duration-300 self-start md:self-auto"
// //         >
// //           Pokaż szczegóły
// //         </button>
// //       </div>

// //       {/* Popup z pełnym opisem */}
// //       <AnimatePresence>
// //         {showPopup && (
// //           <motion.div
// //             className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
// //             initial="hidden"
// //             animate="visible"
// //             exit="hidden"
// //             variants={overlayVariants}
// //           >
// //             <motion.div 
// //               className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto"
// //               initial="hidden"
// //               animate="visible"
// //               exit="exit"
// //               variants={popupVariants}
// //             >
// //               <div className="p-6">
// //                 <div className="flex justify-between items-start mb-4">
// //                   <h3 className="text-2xl font-bold text-gray-800">{title}</h3>
// //                   <button 
// //                     onClick={() => setShowPopup(false)}
// //                     className="text-gray-500 hover:text-gray-700 text-2xl"
// //                   >
// //                     &times;
// //                   </button>
// //                 </div>
// //                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
// //                   <div>
// //                     {/* Galeria zdjęć - jedno pod drugim */}
// //                     <div className="space-y-4">
// //                       {galleryImages.map((img, index) => (
// //                         <div 
// //                           key={img.id} 
// //                           className={`relative ${index === galleryImages.length - 1 ? 'group' : ''}`}
// //                         >
// //                           <ImageViewer 
// //                             src={img.src} 
// //                             alt={`${title} - zdjęcie ${img.id}`}
// //                             onClick={() => openImage(img)}
// //                           />
                          
// //                           {index === galleryImages.length - 1 && (
// //                             <div 
// //                               className="absolute inset-0 bg-yellow-400 bg-opacity-70 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 cursor-pointer"
// //                               onClick={() => setShowFullGallery(true)}
// //                             >
// //                               <span className="text-black font-bold text-lg">
// //                                 Zobacz więcej
// //                               </span>
// //                             </div>
// //                           )}
// //                         </div>
// //                       ))}
// //                     </div>
// //                   </div>
// //                   <div className="text-gray-700">
// //                     {fullDescription}
// //                   </div>
// //                 </div>
// //               </div>
// //             </motion.div>
// //           </motion.div>
// //         )}
// //       </AnimatePresence>

// //       {/* Pełna galeria (modal) */}
// //       {showFullGallery && (
// //         <div className="fixed inset-0 bg-black bg-opacity-90 z-50 overflow-y-auto p-4">
// //           <button 
// //             onClick={() => setShowFullGallery(false)}
// //             className="fixed top-4 right-4 bg-white px-4 py-2 rounded-md z-50 hover:bg-gray-200 transition-colors"
// //           >
// //             Zamknij
// //           </button>
          
// //           <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 pt-12">
// //             {galleryImages.map(img => (
// //               <div key={img.id} className="aspect-square overflow-hidden">
// //                 <ImageViewer 
// //                   src={img.src} 
// //                   alt={`${title} - zdjęcie ${img.id}`}
// //                   onClick={() => openImage(img)}
// //                 />
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //       )}

// //       {/* Powiększone zdjęcie */}
// //       {currentImage && (
// //         <div 
// //           className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
// //           onClick={closeImage}
// //         >
// //           <div className="relative max-w-6xl max-h-[90vh]">
// //             <button 
// //               className="absolute -top-12 right-0 bg-white px-4 py-2 rounded-md hover:bg-gray-200 transition-colors"
// //               onClick={closeImage}
// //             >
// //               Zamknij
// //             </button>
// //             <img
// //               src={currentImage.src}
// //               alt={`Powiększone ${title}`}
// //               className="max-w-full max-h-[80vh] object-contain"
// //             />
// //           </div>
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // const Offer = () => {
// //   const domkiShortDescription = "Oferujemy Państwu piętrowe kolorowe drewniane domki, w pełni wyposażone. W domku spokojnie może zamieszkać rodzina 4-6 osobowa.";
  
// //   const domkiImages = [
// //     { id: 1, src: '/images/oferta1.jpg' },
// //     { id: 2, src: '/images/oferta3.jpg' },
// //     { id: 3, src: '/images/oferta4.jpg' },
// //     { id: 4, src: '/images/oferta5.png' }
// //   ];
  
// //   const domkiFullDescription = (
// //     <div className="space-y-4">
// //       <div>
// //         <p className="font-semibold mb-2">Do dyspozycji Gości oddajemy:</p>
// //         <ul className="list-disc pl-5 space-y-1">
// //           <li>Parking, 1 miejsce parkingowe na domek</li>
// //           <li>Atrakcyjny plac zabaw dla dzieci na ogrodzonym terenie</li>
// //           <li>Miejsce do grillowania</li>
// //           <li>Internet bezprzewodowy WiFi</li>
// //           <li>Kijki do Nordic Walking</li>
// //           <li>Kojec dla dzieci - udostępniamy na życzenie Gości</li>
// //         </ul>
// //       </div>

// //       <div className="mt-4">
// //         <p className="font-semibold">PARTER</p>
// //         <p className="font-medium mt-2">ANEKS KUCHENNY:</p>
// //         <ul className="list-disc pl-5 space-y-1">
// //           <li>Lodówka podblatowa</li>
// //           <li>Kuchenka elektryczna 2 palnikowa</li>
// //           <li>Mikrofalówka, czajnik</li>
// //           <li>Komplet garnków, patelnia</li>
// //           <li>Komplet talerzy i sztućców dla 6 osób</li>
// //           <li>Zlewozmywak</li>
// //         </ul>

// //         <p className="font-medium mt-2">ŁAZIENKA:</p>
// //         <ul className="list-disc pl-5 space-y-1">
// //           <li>Kabina prysznicowa</li>
// //           <li>Umywalka z szafką</li>
// //           <li>Kompakt WC</li>
// //           <li>Szafka, lustro, suszarka do włosów</li>
// //         </ul>

// //         <p className="font-medium mt-2">POKÓJ DZIENNY:</p>
// //         <ul className="list-disc pl-5 space-y-1">
// //           <li>Sofa z funkcją spania dla 2 osób</li>
// //           <li>Stolik kawowy i TV</li>
// //           <li>Składany stolik z krzesłami</li>
// //           <li>Telewizor LCD 22 calowy z TV SAT</li>
// //           <li>Szafa</li>
// //         </ul>

// //         <p className="mt-2">Taras ze stołem i krzesłami</p>
// //       </div>

// //       <div className="mt-4">
// //         <p className="font-semibold">PIĘTRO</p>
// //         <p className="font-medium mt-2">OTWARTA SYPIALNIA:</p>
// //         <ul className="list-disc pl-5 space-y-1">
// //           <li>2 łóżka pojedyncze oraz jedno podwójne</li>
// //           <li>Komoda</li>
// //           <li>Lampka nocna</li>
// //         </ul>
// //       </div>

// //       <p className="mt-4">Każdy domek wyposażony w parawan na plażę, 2 leżaki oraz koc.</p>
// //     </div>
// //   );

// //   const apartamentyShortDescription = "Oferujemy Państwu piętrowe, komfortowe i w pełni wyposażone apartamenty z 2 sypialniami. W apartamencie może zamieszkać rodzina 4-8 osobowa.";
  
// //   const apartamentyImages = [
// //     { id: 1, src: '/images/ofertadeluxe1.jpg' },
// //     { id: 2, src: '/images/ofertadeluxe2.jpg' },
// //     { id: 3, src: '/images/ofertadeluxe3.jpg' },
// //     { id: 4, src: '/images/ofertadeluxe4.jpg' },
// //     { id: 4, src: '/images/ofertadeluxe5.jpg' }
// //   ];
  
// //   const apartamentyFullDescription = (
// //     <div className="space-y-4">
// //       <div>
// //         <p className="font-semibold mb-2">Do dyspozycji naszych Gości oddajemy:</p>
// //         <ul className="list-disc pl-5 space-y-1">
// //           <li>Parking</li>
// //           <li>Atrakcyjny plac zabaw dla dzieci na ogrodzonym terenie</li>
// //           <li>Duży teren zielony do wypoczynku z hamakami i leżakami</li>
// //           <li>Kameralną atmosferę, tylko 3 apartamenty na działce</li>
// //           <li>Miejsce do grillowania</li>
// //           <li>Internet bezprzewodowy WiFi</li>
// //           <li>Kijki do Nordic Walking</li>
// //           <li>Kojec dla dzieci - udostępniamy na życzenie Gości</li>
// //         </ul>
// //       </div>

// //       <div className="mt-4">
// //         <p className="font-semibold">PARTER</p>
        
// //         <p className="font-medium mt-2">ANEKS KUCHENNY:</p>
// //         <ul className="list-disc pl-5 space-y-1">
// //           <li>Lodówka z zamrażarką</li>
// //           <li>Kuchenka elektryczna 4-palnikowa</li>
// //           <li>Zmywarka i zlewozmywak</li>
// //           <li>Mikrofalówka, czajnik i ekspres do kawy Tchibo Cafissimo na kapsułki</li>
// //           <li>Komplet garnków i patelni</li>
// //           <li>Komplet talerzy i sztućców dla 8 osób</li>
// //         </ul>

// //         <p className="font-medium mt-2">ŁAZIENKA:</p>
// //         <ul className="list-disc pl-5 space-y-1">
// //           <li>Kabina prysznicowa</li>
// //           <li>Umywalka z szafką</li>
// //           <li>Kompakt WC</li>
// //           <li>Lustro, wieszaki, suszarka do włosów</li>
// //         </ul>

// //         <p className="font-medium mt-2">SALON:</p>
// //         <ul className="list-disc pl-5 space-y-1">
// //           <li>Narożnik z funkcją spania dla 2 osób</li>
// //           <li>Stolik kawowy</li>
// //           <li>Szafka</li>
// //           <li>Telewizor LCD 32 calowy z TV SAT</li>
// //           <li>Duży stół dla 4-8 osób</li>
// //           <li>Taras ze stołem i krzesłami</li>
// //         </ul>
// //       </div>

// //       <div className="mt-4">
// //         <p className="font-semibold">PIĘTRO</p>
        
// //         <p className="font-medium mt-2">SYPIALNIA NR 1:</p>
// //         <ul className="list-disc pl-5 space-y-1">
// //           <li>1 łóżko pojedyncze oraz jedno podwójne</li>
// //           <li>Szafa</li>
// //           <li>Półki i lampki nocne</li>
// //           <li>Balkon z widokiem na las</li>
// //         </ul>

// //         <p className="font-medium mt-2">SYPIALNIA NR 2:</p>
// //         <ul className="list-disc pl-5 space-y-1">
// //           <li>3 łóżka pojedyncze</li>
// //           <li>Komoda</li>
// //           <li>Półki i lampki nocne</li>
// //         </ul>
// //       </div>

// //       <p className="mt-4">Każdy domek wyposażony w parawan na plażę, 2 leżaki oraz koc.</p>
// //     </div>
// //   );

// //   return (
// //     <section className="py-12 bg-[#edece8]">
// //       <div className="max-w-6xl mx-auto px-4">
// //         <h2 className="text-3xl font-bold text-center mb-12">Nasza oferta</h2>
// //         <div className="flex flex-col gap-12">
// //           <OfferCard
// //             image="/images/oferta4.jpg"
// //             title="DOMKI 4-6 osobowe"
// //             shortDescription={domkiShortDescription}
// //             fullDescription={domkiFullDescription}
// //             galleryImages={domkiImages}
// //           />
          
// //           <OfferCard
// //             image="/images/ofertadeluxe2.jpg"
// //             title="APARTAMENTY KOLOROWE DOMKI"
// //             shortDescription={apartamentyShortDescription}
// //             fullDescription={apartamentyFullDescription}
// //             galleryImages={apartamentyImages}
// //             reverse={true}
// //           />
// //         </div>
// //       </div>
// //     </section>
// //   );
// // };

// // export default Offer;

// import React, { useState, useEffect } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';

// const ImageViewer = ({ src, alt, onClick }) => {
//   const [isHovered, setIsHovered] = useState(false);

//   return (
//     <div 
//       className="relative rounded-lg overflow-hidden cursor-zoom-in"
//       onMouseEnter={() => setIsHovered(true)}
//       onMouseLeave={() => setIsHovered(false)}
//       onClick={onClick}
//     >
//       <img
//         src={src}
//         alt={alt}
//         className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
//         onError={(e) => {
//           e.target.src = '/images/placeholder.jpg';
//           console.error(`Błąd ładowania obrazu: ${src}`);
//         }}
//       />
//       {isHovered && (
//         <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center">
//           <span className="text-white font-bold text-lg bg-black bg-opacity-50 px-3 py-1 rounded-md">
//             Powiększ
//           </span>
//         </div>
//       )}
//     </div>
//   );
// };

// const OfferCard = ({ image, title, shortDescription, fullDescription, reverse = false, galleryImages = [] }) => {
//   const [showPopup, setShowPopup] = useState(false);
//   const [showFullGallery, setShowFullGallery] = useState(false);
//   const [currentImage, setCurrentImage] = useState(null);

//   const popupVariants = {
//     hidden: { 
//       opacity: 0,
//       scale: 0.8,
//       transition: { duration: 0.2 }
//     },
//     visible: { 
//       opacity: 1,
//       scale: 1,
//       transition: { 
//         duration: 0.3,
//         ease: "easeOut"
//       }
//     },
//     exit: {
//       opacity: 0,
//       scale: 0.8,
//       transition: { duration: 0.2 }
//     }
//   };

//   const overlayVariants = {
//     hidden: { opacity: 0 },
//     visible: { opacity: 1 }
//   };

//   const openImage = (img) => {
//     setCurrentImage(img);
//   };

//   const closeImage = () => {
//     setCurrentImage(null);
//   };

//   return (
//     <div className={`flex flex-col ${reverse ? 'md:flex-row-reverse' : 'md:flex-row'} gap-6 md:gap-8 lg:gap-12 rounded-lg shadow-lg overflow-hidden bg-white`}>
//       {/* Sekcja zdjęcia */}
//       <div className="md:w-1/2">
//         <div className="aspect-w-16 aspect-h-9 md:aspect-w-4 md:aspect-h-3">
//           <img
//             src={image}
//             alt={title}
//             className="w-full h-full object-cover"
//           />
//         </div>
//       </div>

//       {/* Sekcja opisu */}
//       <div className={`p-6 md:p-8 md:w-1/2 flex flex-col ${reverse ? 'md:text-right' : 'md:text-left'}`}>
//         <h3 className="text-2xl md:text-3xl font-bold mb-4 text-gray-800">{title}</h3>
//         <p className="text-gray-600 mb-6">{shortDescription}</p>
        
//         <button 
//           onClick={() => setShowPopup(true)}
//           className="mt-2 bg-yellow-500 hover:bg-yellow-600 text-white py-2 px-6 rounded-md transition-colors duration-300 self-start md:self-auto"
//         >
//           Pokaż szczegóły
//         </button>
//       </div>

//       {/* Popup z pełnym opisem */}
//       <AnimatePresence>
//         {showPopup && (
//           <motion.div
//             className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
//             initial="hidden"
//             animate="visible"
//             exit="hidden"
//             variants={overlayVariants}
//           >
//             <motion.div 
//               className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto"
//               initial="hidden"
//               animate="visible"
//               exit="exit"
//               variants={popupVariants}
//             >
//               <div className="p-6">
//                 <div className="flex justify-between items-start mb-4">
//                   <h3 className="text-2xl font-bold text-gray-800">{title}</h3>
//                   <button 
//                     onClick={() => setShowPopup(false)}
//                     className="text-gray-500 hover:text-gray-700 text-2xl"
//                   >
//                     &times;
//                   </button>
//                 </div>
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                   <div>
//                     {/* Galeria zdjęć - jedno pod drugim */}
//                     <div className="space-y-4">
//                       {galleryImages.map((img, index) => (
//                         <div 
//                           key={img.id} 
//                           className={`relative ${index === galleryImages.length - 1 ? 'group' : ''}`}
//                         >
//                           <ImageViewer 
//                             src={img.src} 
//                             alt={`${title} - zdjęcie ${img.id}`}
//                             onClick={() => openImage(img)}
//                           />
                          
//                           {index === galleryImages.length - 1 && (
//                             <div 
//                               className="absolute inset-0 bg-yellow-400 bg-opacity-70 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 cursor-pointer"
//                               onClick={() => setShowFullGallery(true)}
//                             >
//                               <span className="text-black font-bold text-lg">
//                                 Zobacz więcej
//                               </span>
//                             </div>
//                           )}
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                   <div className="text-gray-700">
//                     {fullDescription}
//                   </div>
//                 </div>
//               </div>
//             </motion.div>
//           </motion.div>
//         )}
//       </AnimatePresence>

//       {/* Pełna galeria (modal) */}
//       {showFullGallery && (
//         <div className="fixed inset-0 bg-black bg-opacity-90 z-50 overflow-y-auto p-4">
//           <button 
//             onClick={() => setShowFullGallery(false)}
//             className="fixed top-4 right-4 bg-white px-4 py-2 rounded-md z-50 hover:bg-gray-200 transition-colors"
//           >
//             Zamknij
//           </button>
          
//           <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 pt-12">
//             {galleryImages.map(img => (
//               <div key={img.id} className="aspect-square overflow-hidden">
//                 <ImageViewer 
//                   src={img.src} 
//                   alt={`${title} - zdjęcie ${img.id}`}
//                   onClick={() => openImage(img)}
//                 />
//               </div>
//             ))}
//           </div>
//         </div>
//       )}

//       {/* Powiększone zdjęcie */}
//       {currentImage && (
//         <div 
//           className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
//           onClick={closeImage}
//         >
//           <div className="relative max-w-6xl max-h-[90vh]">
//             <button 
//               className="absolute -top-12 right-0 bg-white px-4 py-2 rounded-md hover:bg-gray-200 transition-colors"
//               onClick={closeImage}
//             >
//               Zamknij
//             </button>
//             <img
//               src={currentImage.src}
//               alt={`Powiększone ${title}`}
//               className="max-w-full max-h-[80vh] object-contain"
//             />
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// const Offer = () => {
//   const [offerData, setOfferData] = useState({
//     title: "Nasza oferta",
//     domki: {
//       title: "DOMKI 4-6 osobowe",
//       image: "/images/oferta4.jpg",
//       shortDescription: "Oferujemy Państwu piętrowe kolorowe drewniane domki, w pełni wyposażone. W domku spokojnie może zamieszkać rodzina 4-6 osobowa.",
//       galleryImages: [
//         { id: 1, src: '/images/oferta1.jpg' },
//         { id: 2, src: '/images/oferta3.jpg' },
//         { id: 3, src: '/images/oferta4.jpg' },
//         { id: 4, src: '/images/oferta5.png' }
//       ],
//       fullDescription: {
//         amenities: [
//           "Parking, 1 miejsce parkingowe na domek",
//           "Atrakcyjny plac zabaw dla dzieci na ogrodzonym terenie",
//           "Miejsce do grillowania",
//           "Internet bezprzewodowy WiFi",
//           "Kijki do Nordic Walking",
//           "Kojec dla dzieci - udostępniamy na życzenie Gości"
//         ],
//         parter: {
//           kuchenny: [
//             "Lodówka podblatowa",
//             "Kuchenka elektryczna 2 palnikowa",
//             "Mikrofalówka, czajnik",
//             "Komplet garnków, patelnia",
//             "Komplet talerzy i sztućców dla 6 osób",
//             "Zlewozmywak"
//           ],
//           lazienka: [
//             "Kabina prysznicowa",
//             "Umywalka z szafką",
//             "Kompakt WC",
//             "Szafka, lustro, suszarka do włosów"
//           ],
//           dzienny: [
//             "Sofa z funkcją spania dla 2 osób",
//             "Stolik kawowy i TV",
//             "Składany stolik z krzesłami",
//             "Telewizor LCD 22 calowy z TV SAT",
//             "Szafa"
//           ],
//           taras: "Taras ze stołem i krzesłami"
//         },
//         pietro: {
//           sypialnia: [
//             "2 łóżka pojedyncze oraz jedno podwójne",
//             "Komoda",
//             "Lampka nocna"
//           ]
//         },
//         dodatkowe: "Każdy domek wyposażony w parawan na plażę, 2 leżaki oraz koc."
//       }
//     },
//     apartamenty: {
//       title: "APARTAMENTY KOLOROWE DOMKI",
//       image: "/images/ofertadeluxe2.jpg",
//       shortDescription: "Oferujemy Państwu piętrowe, komfortowe i w pełni wyposażone apartamenty z 2 sypialniami. W apartamencie może zamieszkać rodzina 4-8 osobowa.",
//       galleryImages: [
//         { id: 1, src: '/images/ofertadeluxe1.jpg' },
//         { id: 2, src: '/images/ofertadeluxe2.jpg' },
//         { id: 3, src: '/images/ofertadeluxe3.jpg' },
//         { id: 4, src: '/images/ofertadeluxe4.jpg' },
//         { id: 5, src: '/images/ofertadeluxe5.jpg' }
//       ],
//       fullDescription: {
//         amenities: [
//           "Parking",
//           "Atrakcyjny plac zabaw dla dzieci na ogrodzonym terenie",
//           "Duży teren zielony do wypoczynku z hamakami i leżakami",
//           "Kameralną atmosferę, tylko 3 apartamenty na działce",
//           "Miejsce do grillowania",
//           "Internet bezprzewodowy WiFi",
//           "Kijki do Nordic Walking",
//           "Kojec dla dzieci - udostępniamy na życzenie Gości"
//         ],
//         parter: {
//           kuchenny: [
//             "Lodówka z zamrażarką",
//             "Kuchenka elektryczna 4-palnikowa",
//             "Zmywarka i zlewozmywak",
//             "Mikrofalówka, czajnik i ekspres do kawy Tchibo Cafissimo na kapsułki",
//             "Komplet garnków i patelni",
//             "Komplet talerzy i sztućców dla 8 osób"
//           ],
//           lazienka: [
//             "Kabina prysznicowa",
//             "Umywalka z szafką",
//             "Kompakt WC",
//             "Lustro, wieszaki, suszarka do włosów"
//           ],
//           salon: [
//             "Narożnik z funkcją spania dla 2 osób",
//             "Stolik kawowy",
//             "Szafka",
//             "Telewizor LCD 32 calowy z TV SAT",
//             "Duży stół dla 4-8 osób",
//             "Taras ze stołem i krzesłami"
//           ]
//         },
//         pietro: {
//           sypialnia1: [
//             "1 łóżko pojedyncze oraz jedno podwójne",
//             "Szafa",
//             "Półki i lampki nocne",
//             "Balkon z widokiem na las"
//           ],
//           sypialnia2: [
//             "3 łóżka pojedyncze",
//             "Komoda",
//             "Półki i lampki nocne"
//           ]
//         },
//         dodatkowe: "Każdy domek wyposażony w parawan na plażę, 2 leżaki oraz koc."
//       }
//     }
//   });

//   useEffect(() => {
//     const savedData = localStorage.getItem('offerData');
//     if (savedData) {
//       try {
//         const parsedData = JSON.parse(savedData);
//         setOfferData(parsedData);
//       } catch (error) {
//         console.error('Błąd parsowania danych oferty:', error);
//       }
//     }
//   }, []);

//   // Funkcja konwertująca dane na JSX
//   const renderFullDescription = (description) => {
//     if (!description) return <div>Brak opisu</div>;
    
//     return (
//       <div className="space-y-4">
//         {description.amenities && description.amenities.length > 0 && (
//           <div>
//             <p className="font-semibold mb-2">Do dyspozycji Gości oddajemy:</p>
//             <ul className="list-disc pl-5 space-y-1">
//               {description.amenities.map((item, index) => (
//                 <li key={index}>{item}</li>
//               ))}
//             </ul>
//           </div>
//         )}

//         {description.parter && (
//           <div className="mt-4">
//             <p className="font-semibold">PARTER</p>
            
//             {description.parter.kuchenny && description.parter.kuchenny.length > 0 && (
//               <>
//                 <p className="font-medium mt-2">ANEKS KUCHENNY:</p>
//                 <ul className="list-disc pl-5 space-y-1">
//                   {description.parter.kuchenny.map((item, index) => (
//                     <li key={index}>{item}</li>
//                   ))}
//                 </ul>
//               </>
//             )}

//             {description.parter.lazienka && description.parter.lazienka.length > 0 && (
//               <>
//                 <p className="font-medium mt-2">ŁAZIENKA:</p>
//                 <ul className="list-disc pl-5 space-y-1">
//                   {description.parter.lazienka.map((item, index) => (
//                     <li key={index}>{item}</li>
//                   ))}
//                 </ul>
//               </>
//             )}

//             {description.parter.dzienny && description.parter.dzienny.length > 0 && (
//               <>
//                 <p className="font-medium mt-2">POKÓJ DZIENNY:</p>
//                 <ul className="list-disc pl-5 space-y-1">
//                   {description.parter.dzienny.map((item, index) => (
//                     <li key={index}>{item}</li>
//                   ))}
//                 </ul>
//               </>
//             )}

//             {description.parter.salon && description.parter.salon.length > 0 && (
//               <>
//                 <p className="font-medium mt-2">SALON:</p>
//                 <ul className="list-disc pl-5 space-y-1">
//                   {description.parter.salon.map((item, index) => (
//                     <li key={index}>{item}</li>
//                   ))}
//                 </ul>
//               </>
//             )}

//             {description.parter.taras && (
//               <p className="mt-2">{description.parter.taras}</p>
//             )}
//           </div>
//         )}

//         {description.pietro && (
//           <div className="mt-4">
//             <p className="font-semibold">PIĘTRO</p>
            
//             {description.pietro.sypialnia && description.pietro.sypialnia.length > 0 && (
//               <>
//                 <p className="font-medium mt-2">OTWARTA SYPIALNIA:</p>
//                 <ul className="list-disc pl-5 space-y-1">
//                   {description.pietro.sypialnia.map((item, index) => (
//                     <li key={index}>{item}</li>
//                   ))}
//                 </ul>
//               </>
//             )}

//             {description.pietro.sypialnia1 && description.pietro.sypialnia1.length > 0 && (
//               <>
//                 <p className="font-medium mt-2">SYPIALNIA NR 1:</p>
//                 <ul className="list-disc pl-5 space-y-1">
//                   {description.pietro.sypialnia1.map((item, index) => (
//                     <li key={index}>{item}</li>
//                   ))}
//                 </ul>
//               </>
//             )}

//             {description.pietro.sypialnia2 && description.pietro.sypialnia2.length > 0 && (
//               <>
//                 <p className="font-medium mt-2">SYPIALNIA NR 2:</p>
//                 <ul className="list-disc pl-5 space-y-1">
//                   {description.pietro.sypialnia2.map((item, index) => (
//                     <li key={index}>{item}</li>
//                   ))}
//                 </ul>
//               </>
//             )}
//           </div>
//         )}

//         {description.dodatkowe && (
//           <p className="mt-4">{description.dodatkowe}</p>
//         )}
//       </div>
//     );
//   };

//   return (
//     <section className="py-12 bg-[#edece8]">
//       <div className="max-w-6xl mx-auto px-4">
//         <h2 className="text-3xl font-bold text-center mb-12">{offerData.title}</h2>
//         <div className="flex flex-col gap-12">
//           <OfferCard
//             image={offerData.domki.image}
//             title={offerData.domki.title}
//             shortDescription={offerData.domki.shortDescription}
//             fullDescription={renderFullDescription(offerData.domki.fullDescription)}
//             galleryImages={offerData.domki.galleryImages}
//           />
          
//           <OfferCard
//             image={offerData.apartamenty.image}
//             title={offerData.apartamenty.title}
//             shortDescription={offerData.apartamenty.shortDescription}
//             fullDescription={renderFullDescription(offerData.apartamenty.fullDescription)}
//             galleryImages={offerData.apartamenty.galleryImages}
//             reverse={true}
//           />
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Offer;

import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const ImageViewer = ({ src, alt, onClick }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div 
      className="relative rounded-lg overflow-hidden cursor-zoom-in"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClick}
    >
      <img
        src={src}
        alt={alt}
        className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
        onError={(e) => {
          e.target.src = '/images/placeholder.jpg';
          console.error(`Błąd ładowania obrazu: ${src}`);
        }}
      />
      {isHovered && (
        <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center">
          <span className="text-white font-bold text-lg bg-black bg-opacity-50 px-3 py-1 rounded-md">
            Powiększ
          </span>
        </div>
      )}
    </div>
  );
};
const OfferCard = ({ image, title, shortDescription, fullDescription, reverse = false, galleryImages = [] }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [showFullGallery, setShowFullGallery] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);

  const popupVariants = {
    hidden: { 
      opacity: 0,
      scale: 0.8,
      transition: { duration: 0.2 }
    },
    visible: { 
      opacity: 1,
      scale: 1,
      transition: { 
        duration: 0.3,
        ease: "easeOut"
      }
    },
    exit: {
      opacity: 0,
      scale: 0.8,
      transition: { duration: 0.2 }
    }
  };

  const overlayVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 }
  };

  const openImage = (img) => {
    setCurrentImage(img);
  };

  const closeImage = () => {
    setCurrentImage(null);
  };

  return (
    <div className={`flex flex-col ${reverse ? 'md:flex-row-reverse' : 'md:flex-row'} gap-6 md:gap-8 lg:gap-12 rounded-lg shadow-lg overflow-hidden bg-white`}>
      {/* Sekcja zdjęcia */}
      <div className="md:w-1/2">
        <div className="aspect-w-16 aspect-h-9 md:aspect-w-4 md:aspect-h-3">
          <img
            src={image}
            alt={title}
            className="w-full h-full object-cover"
            onError={(e) => {
              e.target.src = '/images/placeholder.jpg';
            }}
          />
        </div>
      </div>

      {/* Sekcja opisu */}
      <div className={`p-6 md:p-8 md:w-1/2 flex flex-col ${reverse ? 'md:text-right' : 'md:text-left'}`}>
        <h3 className="text-2xl md:text-3xl font-bold mb-4 text-gray-800">{title}</h3>
        <p className="text-gray-600 mb-6">{shortDescription}</p>
        
        <button 
          onClick={() => setShowPopup(true)}
          className="mt-2 bg-yellow-500 hover:bg-yellow-600 text-white py-2 px-6 rounded-md transition-colors duration-300 self-start md:self-auto"
        >
          Pokaż szczegóły
        </button>
      </div>

      {/* Popup z pełnym opisem */}
      <AnimatePresence>
        {showPopup && (
          <motion.div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={overlayVariants}
          >
            <motion.div 
              className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto"
              initial="hidden"
              animate="visible"
              exit="exit"
              variants={popupVariants}
            >
              <div className="p-6">
                <div className="flex justify-between items-start mb-4">
                  <h3 className="text-2xl font-bold text-gray-800">{title}</h3>
                  <button 
                    onClick={() => setShowPopup(false)}
                    className="text-gray-500 hover:text-gray-700 text-2xl"
                  >
                    &times;
                  </button>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    {/* Galeria zdjęć - tylko 3 pierwsze zdjęcia */}
                    <div className="space-y-4">
                      {galleryImages.slice(0, 3).map((img, index) => (
                        <div 
                          key={img.id} 
                          className={`relative ${index === 2 && galleryImages.length > 3 ? 'group' : ''}`}
                        >
                          <ImageViewer 
                            src={img.src} 
                            alt={`${title} - zdjęcie ${img.id}`}
                            onClick={() => openImage(img)}
                          />
                          
                          {/* Overlay "Zobacz więcej" tylko na trzecim zdjęciu jeśli są więcej niż 3 zdjęcia */}
                          {index === 2 && galleryImages.length > 3 && (
                            <div 
                              className="absolute inset-0 bg-yellow-400 bg-opacity-70 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 cursor-pointer"
                              onClick={() => setShowFullGallery(true)}
                            >
                              <span className="text-black font-bold text-lg">
                                Zobacz więcej ({galleryImages.length - 3} zdjęć)
                              </span>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="text-gray-700">
                    {fullDescription}
                  </div>
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Modal pełnej galerii */}
      <AnimatePresence>
        {showFullGallery && (
          <motion.div
            className="fixed inset-0 bg-black bg-opacity-90 z-[60] flex items-center justify-center p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div 
              className="bg-white rounded-lg max-w-6xl w-full max-h-[90vh] overflow-y-auto"
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: 50, opacity: 0 }}
              transition={{ duration: 0.3 }}
            >
              <div className="p-6">
                <div className="flex justify-between items-center mb-6">
                  <h3 className="text-2xl font-bold text-gray-800">{title} - Galeria</h3>
                  <button 
                    onClick={() => setShowFullGallery(false)}
                    className="text-gray-500 hover:text-gray-700 text-2xl"
                  >
                    &times;
                  </button>
                </div>
                
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                  {galleryImages.map(img => (
                    <div key={img.id} className="aspect-square overflow-hidden rounded-lg">
                      <ImageViewer 
                        src={img.src} 
                        alt={`${title} - zdjęcie ${img.id}`}
                        onClick={() => openImage(img)}
                      />
                    </div>
                  ))}
                </div>
                
                <div className="mt-6 text-center">
                  <button 
                    onClick={() => setShowFullGallery(false)}
                    className="bg-yellow-500 hover:bg-yellow-600 text-white py-2 px-6 rounded-md transition-colors duration-300"
                  >
                    Zamknij galerię
                  </button>
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Powiększone zdjęcie */}
      {currentImage && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-90 z-[70] flex items-center justify-center p-4"
          onClick={closeImage}
        >
          <div className="relative max-w-6xl max-h-[90vh]" onClick={(e) => e.stopPropagation()}>
            <button 
              className="absolute -top-12 right-0 bg-white px-4 py-2 rounded-md hover:bg-gray-200 transition-colors z-10"
              onClick={closeImage}
            >
              Zamknij
            </button>
            <img
              src={currentImage.src}
              alt={`Powiększone ${title}`}
              className="max-w-full max-h-[80vh] object-contain"
              onError={(e) => {
                e.target.src = '/images/placeholder.jpg';
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};
// const OfferCard = ({ image, title, shortDescription, fullDescription, reverse = false, galleryImages = [] }) => {
//   const [showPopup, setShowPopup] = useState(false);
//   const [showFullGallery, setShowFullGallery] = useState(false);
//   const [currentImage, setCurrentImage] = useState(null);

//   const popupVariants = {
//     hidden: { 
//       opacity: 0,
//       scale: 0.8,
//       transition: { duration: 0.2 }
//     },
//     visible: { 
//       opacity: 1,
//       scale: 1,
//       transition: { 
//         duration: 0.3,
//         ease: "easeOut"
//       }
//     },
//     exit: {
//       opacity: 0,
//       scale: 0.8,
//       transition: { duration: 0.2 }
//     }
//   };

//   const overlayVariants = {
//     hidden: { opacity: 0 },
//     visible: { opacity: 1 }
//   };

//   const openImage = (img) => {
//     setCurrentImage(img);
//   };

//   const closeImage = () => {
//     setCurrentImage(null);
//   };

//   return (
//     <div className={`flex flex-col ${reverse ? 'md:flex-row-reverse' : 'md:flex-row'} gap-6 md:gap-8 lg:gap-12 rounded-lg shadow-lg overflow-hidden bg-white`}>
//       {/* Sekcja zdjęcia */}
//       <div className="md:w-1/2">
//         <div className="aspect-w-16 aspect-h-9 md:aspect-w-4 md:aspect-h-3">
//           <img
//             src={image}
//             alt={title}
//             className="w-full h-full object-cover"
//             onError={(e) => {
//               e.target.src = '/images/placeholder.jpg';
//             }}
//           />
//         </div>
//       </div>

//       {/* Sekcja opisu */}
//       <div className={`p-6 md:p-8 md:w-1/2 flex flex-col ${reverse ? 'md:text-right' : 'md:text-left'}`}>
//         <h3 className="text-2xl md:text-3xl font-bold mb-4 text-gray-800">{title}</h3>
//         <p className="text-gray-600 mb-6">{shortDescription}</p>
        
//         <button 
//           onClick={() => setShowPopup(true)}
//           className="mt-2 bg-yellow-500 hover:bg-yellow-600 text-white py-2 px-6 rounded-md transition-colors duration-300 self-start md:self-auto"
//         >
//           Pokaż szczegóły
//         </button>
//       </div>

//       {/* Popup z pełnym opisem */}
//       <AnimatePresence>
//         {showPopup && (
//           <motion.div
//             className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
//             initial="hidden"
//             animate="visible"
//             exit="hidden"
//             variants={overlayVariants}
//           >
//             <motion.div 
//               className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto"
//               initial="hidden"
//               animate="visible"
//               exit="exit"
//               variants={popupVariants}
//             >
//               <div className="p-6">
//                 <div className="flex justify-between items-start mb-4">
//                   <h3 className="text-2xl font-bold text-gray-800">{title}</h3>
//                   <button 
//                     onClick={() => setShowPopup(false)}
//                     className="text-gray-500 hover:text-gray-700 text-2xl"
//                   >
//                     &times;
//                   </button>
//                 </div>
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                   <div>
//                     {/* Galeria zdjęć - jedno pod drugim */}
//                     <div className="space-y-4">
//                       {galleryImages.map((img, index) => (
//                         <div 
//                           key={img.id} 
//                           className={`relative ${index === galleryImages.length - 1 ? 'group' : ''}`}
//                         >
//                           <ImageViewer 
//                             src={img.src} 
//                             alt={`${title} - zdjęcie ${img.id}`}
//                             onClick={() => openImage(img)}
//                           />
                          
//                           {index === galleryImages.length - 1 && (
//                             <div 
//                               className="absolute inset-0 bg-yellow-400 bg-opacity-70 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 cursor-pointer"
//                               onClick={() => setShowFullGallery(true)}
//                             >
//                               <span className="text-black font-bold text-lg">
//                                 Zobacz więcej
//                               </span>
//                             </div>
//                           )}
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                   <div className="text-gray-700">
//                     {fullDescription}
//                   </div>
//                 </div>
//               </div>
//             </motion.div>
//           </motion.div>
//         )}
//       </AnimatePresence>

//       {/* Pełna galeria (modal) */}
//       {showFullGallery && (
//         <div className="fixed inset-0 bg-black bg-opacity-90 z-50 overflow-y-auto p-4">
//           <button 
//             onClick={() => setShowFullGallery(false)}
//             className="fixed top-4 right-4 bg-white px-4 py-2 rounded-md z-50 hover:bg-gray-200 transition-colors"
//           >
//             Zamknij
//           </button>
          
//           <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 pt-12">
//             {galleryImages.map(img => (
//               <div key={img.id} className="aspect-square overflow-hidden">
//                 <ImageViewer 
//                   src={img.src} 
//                   alt={`${title} - zdjęcie ${img.id}`}
//                   onClick={() => openImage(img)}
//                 />
//               </div>
//             ))}
//           </div>
//         </div>
//       )}

//       {/* Powiększone zdjęcie */}
//       {currentImage && (
//         <div 
//           className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
//           onClick={closeImage}
//         >
//           <div className="relative max-w-6xl max-h-[90vh]">
//             <button 
//               className="absolute -top-12 right-0 bg-white px-4 py-2 rounded-md hover:bg-gray-200 transition-colors"
//               onClick={closeImage}
//             >
//               Zamknij
//             </button>
//             <img
//               src={currentImage.src}
//               alt={`Powiększone ${title}`}
//               className="max-w-full max-h-[80vh] object-contain"
//               onError={(e) => {
//                 e.target.src = '/images/placeholder.jpg';
//               }}
//             />
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

const Offer = () => {
  const API_BASE = 'http://localhost/api';

  const [offerData, setOfferData] = useState({
    title: "Nasza oferta",
    domki: {
      title: "DOMKI 4-6 osobowe",
      image: "/images/oferta4.jpg",
      shortDescription: "Oferujemy Państwu piętrowe kolorowe drewniane domki, w pełni wyposażone. W domku spokojnie może zamieszkać rodzina 4-6 osobowa.",
      galleryImages: [
        { id: 1, src: '/images/oferta1.jpg' },
        { id: 2, src: '/images/oferta3.jpg' },
        { id: 3, src: '/images/oferta4.jpg' },
        { id: 4, src: '/images/oferta5.jpg' },
        { id: 5, src: '/images/oferta6.jpg' },
        { id: 6, src: '/images/oferta7.jpg' },
        { id: 7, src: '/images/oferta8.jpg' },
        { id: 8, src: '/images/oferta9.jpg' },
        { id: 9, src: '/images/oferta10.jpg' },
        { id: 10, src: '/images/oferta11.jpg' },
        { id: 11, src: '/images/oferta12.jpg' },
        { id: 12, src: '/images/oferta13.jpg' }
      ],
      fullDescription: {
        amenities: [
          "Parking, 1 miejsce parkingowe na domek",
          "Atrakcyjny plac zabaw dla dzieci na ogrodzonym terenie",
          "Miejsce do grillowania",
          "Internet bezprzewodowy WiFi",
          "Kijki do Nordic Walking",
          "Kojec dla dzieci - udostępniamy na życzenie Gości"
        ],
        parter: {
          kuchenny: [
            "Lodówka podblatowa",
            "Kuchenka elektryczna 2 palnikowa",
            "Mikrofalówka, czajnik",
            "Komplet garnków, patelnia",
            "Komplet talerzy i sztućców dla 6 osób",
            "Zlewozmywak"
          ],
          lazienka: [
            "Kabina prysznicowa",
            "Umywalka z szafką",
            "Kompakt WC",
            "Szafka, lustro, suszarka do włosów"
          ],
          dzienny: [
            "Sofa z funkcją spania dla 2 osób",
            "Stolik kawowy i TV",
            "Składany stolik z krzesłami",
            "Telewizor LCD 22 calowy z TV SAT",
            "Szafa"
          ],
          taras: "Taras ze stołem i krzesłami"
        },
        pietro: {
          sypialnia: [
            "2 łóżka pojedyncze oraz jedno podwójne",
            "Komoda",
            "Lampka nocna"
          ]
        },
        dodatkowe: "Każdy domek wyposażony w parawan na plażę, 2 leżaki oraz koc."
      }
    },
    apartamenty: {
      title: "APARTAMENTY KOLOROWE DOMKI",
      image: "/images/ofertadeluxe2.jpg",
      shortDescription: "Oferujemy Państwu piętrowe, komfortowe i w pełni wyposażone apartamenty z 2 sypialniami. W apartamencie może zamieszkać rodzina 4-8 osobowa.",
      galleryImages: [
        { id: 1, src: '/images/ofertadeluxe1.jpg' },
        { id: 2, src: '/images/ofertadeluxe2.jpg' },
        { id: 3, src: '/images/ofertadeluxe3.jpg' },
        { id: 4, src: '/images/ofertadeluxe4.jpg' },
        { id: 5, src: '/images/ofertadeluxe5.jpg' },
        { id: 6, src: '/images/ofertadeluxe6.jpg' },
        { id: 7, src: '/images/ofertadeluxe7.jpg' },
        { id: 8, src: '/images/ofertadeluxe8.jpg' },
        { id: 9, src: '/images/ofertadeluxe9.jpg' }
      ],
      fullDescription: {
        amenities: [
          "Parking",
          "Atrakcyjny plac zabaw dla dzieci na ogrodzonym terenie",
          "Duży teren zielony do wypoczynku z hamakami i leżakami",
          "Kameralną atmosferę, tylko 3 apartamenty na działce",
          "Miejsce do grillowania",
          "Internet bezprzewodowy WiFi",
          "Kijki do Nordic Walking",
          "Kojec dla dzieci - udostępniamy na życzenie Gości"
        ],
        parter: {
          kuchenny: [
            "Lodówka z zamrażarką",
            "Kuchenka elektryczna 4-palnikowa",
            "Zmywarka i zlewozmywak",
            "Mikrofalówka, czajnik i ekspres do kawy Tchibo Cafissimo na kapsułki",
            "Komplet garnków i patelni",
            "Komplet talerzy i sztućców dla 8 osób"
          ],
          lazienka: [
            "Kabina prysznicowa",
            "Umywalka z szafką",
            "Kompakt WC",
            "Lustro, wieszaki, suszarka do włosów"
          ],
          salon: [
            "Narożnik z funkcją spania dla 2 osób",
            "Stolik kawowy",
            "Szafka",
            "Telewizor LCD 32 calowy z TV SAT",
            "Duży stół dla 4-8 osób",
            "Taras ze stołem i krzesłami"
          ]
        },
        pietro: {
          sypialnia1: [
            "1 łóżko pojedyncze oraz jedno podwójne",
            "Szafa",
            "Półki i lampki nocne",
            "Balkon z widokiem na las"
          ],
          sypialnia2: [
            "3 łóżka pojedyncze",
            "Komoda",
            "Półki i lampki nocne"
          ]
        },
        dodatkowe: "Każdy domek wyposażony w parawan na plażę, 2 leżaki oraz koc."
      }
    }
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOfferData = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_BASE}/offer.php`);
        
        if (!response.ok) {
          throw new Error('Błąd podczas pobierania danych oferty');
        }
        
        const data = await response.json();
        
        // Sprawdź czy serwer zwrócił poprawne dane
        if (data && !data.error) {
          setOfferData(data);
        } else {
          console.warn('Serwer zwrócił błąd, używam domyślnych danych');
        }
      } catch (error) {
        console.error('Błąd pobierania danych oferty:', error);
        //setError('Nie udało się załadować danych oferty. Wyświetlam domyślną zawartość.');
        // Używamy domyślnych danych w przypadku błędu
      } finally {
        setLoading(false);
      }
    };

    fetchOfferData();
  }, []);

  // Funkcja konwertująca dane na JSX
  const renderFullDescription = (description) => {
    if (!description) return <div>Brak opisu</div>;
    
    return (
      <div className="space-y-4">
        {description.amenities && description.amenities.length > 0 && (
          <div>
            <p className="font-semibold mb-2">Do dyspozycji Gości oddajemy:</p>
            <ul className="list-disc pl-5 space-y-1">
              {description.amenities.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        )}

        {description.parter && (
          <div className="mt-4">
            <p className="font-semibold">PARTER</p>
            
            {description.parter.kuchenny && description.parter.kuchenny.length > 0 && (
              <>
                <p className="font-medium mt-2">ANEKS KUCHENNY:</p>
                <ul className="list-disc pl-5 space-y-1">
                  {description.parter.kuchenny.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </>
            )}

            {description.parter.lazienka && description.parter.lazienka.length > 0 && (
              <>
                <p className="font-medium mt-2">ŁAZIENKA:</p>
                <ul className="list-disc pl-5 space-y-1">
                  {description.parter.lazienka.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </>
            )}

            {description.parter.dzienny && description.parter.dzienny.length > 0 && (
              <>
                <p className="font-medium mt-2">POKÓJ DZIENNY:</p>
                <ul className="list-disc pl-5 space-y-1">
                  {description.parter.dzienny.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </>
            )}

            {description.parter.salon && description.parter.salon.length > 0 && (
              <>
                <p className="font-medium mt-2">SALON:</p>
                <ul className="list-disc pl-5 space-y-1">
                  {description.parter.salon.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </>
            )}

            {description.parter.taras && (
              <p className="mt-2">{description.parter.taras}</p>
            )}
          </div>
        )}

        {description.pietro && (
          <div className="mt-4">
            <p className="font-semibold">PIĘTRO</p>
            
            {description.pietro.sypialnia && description.pietro.sypialnia.length > 0 && (
              <>
                <p className="font-medium mt-2">OTWARTA SYPIALNIA:</p>
                <ul className="list-disc pl-5 space-y-1">
                  {description.pietro.sypialnia.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </>
            )}

            {description.pietro.sypialnia1 && description.pietro.sypialnia1.length > 0 && (
              <>
                <p className="font-medium mt-2">SYPIALNIA NR 1:</p>
                <ul className="list-disc pl-5 space-y-1">
                  {description.pietro.sypialnia1.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </>
            )}

            {description.pietro.sypialnia2 && description.pietro.sypialnia2.length > 0 && (
              <>
                <p className="font-medium mt-2">SYPIALNIA NR 2:</p>
                <ul className="list-disc pl-5 space-y-1">
                  {description.pietro.sypialnia2.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </>
            )}
          </div>
        )}

        {description.dodatkowe && (
          <p className="mt-4">{description.dodatkowe}</p>
        )}
      </div>
    );
  };

  if (loading) {
    return (
      <section className="py-12 bg-[#edece8]">
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-12 bg-[#edece8]">
      <div className="max-w-6xl mx-auto px-4">
        {error && (
          <div className="mb-6 p-4 bg-yellow-100 border border-yellow-400 rounded-md text-yellow-700">
            {error}
          </div>
        )}
        
        <h2 className="text-3xl font-bold text-center mb-12">{offerData.title}</h2>
        <div className="flex flex-col gap-12">
          <OfferCard
            image={offerData.domki.image}
            title={offerData.domki.title}
            shortDescription={offerData.domki.shortDescription}
            fullDescription={renderFullDescription(offerData.domki.fullDescription)}
            galleryImages={offerData.domki.galleryImages}
          />
          
          <OfferCard
            image={offerData.apartamenty.image}
            title={offerData.apartamenty.title}
            shortDescription={offerData.apartamenty.shortDescription}
            fullDescription={renderFullDescription(offerData.apartamenty.fullDescription)}
            galleryImages={offerData.apartamenty.galleryImages}
            reverse={true}
          />
        </div>
      </div>
    </section>
  );
};

export default Offer;